import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FileAddFilledSvg = function FileAddFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2.249h13.05l4.95 5v15H3zm7.875 14.545V13.84H7.95v-2.273h2.925V8.613h2.25v2.954h2.925v2.273h-2.925v2.954z",
    clipRule: "evenodd"
  }));
};
export var FileAddFilled = function FileAddFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FileAddFilledSvg
  }));
};